<template>
  <div class="main">
    <!-- PROCESSING -->
    <a-result v-if="result === 'processing'">
      <template #icon>
        <a-icon type="loading" />
      </template>
      <h1 slot="title">
        {{ $t('msg.shop.callback.processing.title') }}
      </h1>
      <div slot="subTitle">
        <h4 class="text-secondary p-2">
          {{ $t('msg.shop.callback.processing.subtitle') }}
        </h4>
      </div>
    </a-result>
    <!-- SUCCESS -->
    <a-result status="success" v-else-if="result === 'install-success'">
      <h1 slot="title">
        {{ $t('msg.shop.callback.success.title') }}
      </h1>
      <div slot="subTitle">
        <p class="text-secondary p-2">
          {{ $t('msg.shop.callback.success.subtitle') }}
        </p>
      </div>
      <template #extra>
        <router-link :to="{ path: '/shops', query: { account: account } }">
          <a-button
            type="primary"
            size="large">
            {{ $t('msg.shop.callback.success.action') }}
          </a-button>
        </router-link>
      </template>
    </a-result>
    <!-- SIGNUP -->
    <a-result v-else-if="result === 'signup-success'">
      <template #icon>
        <a-icon type="clock-circle" />
      </template>
      <h1 slot="title">
        {{ $t('msg.shop.callback.signup.title') }}
      </h1>
      <div slot="subTitle">
        <h4 class="text-secondary p-2">
          {{ $t('msg.shop.callback.signup.subtitle') }}
        </h4>
      </div>
      <template #extra>
        <a href="https://academy.jipink.com/docs/intro/?utm_campaign=adoption&utm_source=desk&utm_medium=signup" target="_blank">
          <a-button
            type="primary"
            size="large">
            {{ $t('msg.shop.callback.signup.action') }}
          </a-button>
        </a>
      </template>
    </a-result>
    <!-- FAILURE -->
    <a-result status="error" v-else-if="result === 'failure'">
      <h1 slot="title">
        {{ $t('msg.shop.callback.failure.title') }}
      </h1>
      <div slot="subTitle">
        <h4 class="text-secondary p-2">
          {{ $t('msg.shop.callback.failure.subtitle') }}
        </h4>
      </div>
      <template #extra>
        <router-link :to="{ path: '/shops/connect', query: { type: type, account: account } }">
          <a-button
            type="primary"
            size="large">
            {{ $t('msg.shop.callback.failure.action1') }}
          </a-button>
        </router-link>
        <router-link :to="{ path: '/shops', query: { account: account } }">
          <a-button
            size="large">
            {{ $t('msg.shop.callback.failure.action2') }}
          </a-button>
        </router-link>
      </template>
    </a-result>
  </div>
</template>
<script>
import lms from '@/api/lms'
export default {
  name: 'ShopCallback',
  data: function () {
    return {
      result: 'processing',
    }
  },
  computed: {
    type() {
      return this.$route.query.type
    },
    status() {
      return this.$route.query.status
    },
  },
  mounted() {
    if (this.status) {
      this.result = this.status === 'ok' ? 'install-success' : 'failure'
      return
    }
    if (!this.$auth || !this.$auth.isAuthenticated) {
      this.result = 'failure'
      return
    }
    if (this.account) {
      const payload = { ...this.$route.query, account: this.account }
      lms.platform.install(this.type, payload)
        .then(_ => (this.result = 'install-success'))
        .catch(_ => (this.result = 'failure'))
    } else {
      const payload = { ...this.$route.query }
      lms.platform.signup(this.type, payload)
        .then(_ => (this.result = 'signup-success'))
        .catch(_ => (this.result = 'failure'))
    }
  },
}
</script>
